import { useState, useMemo, useCallback } from 'react';
import { ProcedureType } from '../../../../../../../services/ConfigurationService/types/procedureType';

interface UseProcedureSearchProps {
    availableProcedures: ProcedureType[];
}

interface UseProcedureSearchResult {
    searchTerm: string;
    setSearchTerm: (term: string) => void;
    filteredProcedures: ProcedureType[];
    resetSearch: () => void;
}

export const useProcedureSearch = ({
    availableProcedures
}: UseProcedureSearchProps): UseProcedureSearchResult => {
    const [searchTerm, setSearchTerm] = useState<string>('');

    // Filter and sort available procedures based on search term
    const filteredProcedures = useMemo(() => {
        let filtered = [...availableProcedures]; // Create a copy to avoid mutating the original array

        if (searchTerm.trim()) {
            const lowerSearch = searchTerm.toLowerCase();
            filtered = filtered.filter(proc =>
                proc.code.toLowerCase().includes(lowerSearch) ||
                proc.description.toLowerCase().includes(lowerSearch) ||
                proc.codeType.toLowerCase().includes(lowerSearch)
            );
        }

        // Sort by code
        return filtered.sort((a, b) => a.code.localeCompare(b.code));
    }, [availableProcedures, searchTerm]);

    const resetSearch = useCallback(() => {
        setSearchTerm('');
    }, []);

    return {
        searchTerm,
        setSearchTerm,
        filteredProcedures,
        resetSearch
    };
};
